<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import MlssForm from './MlssForm';
import MlssFieldEditor from './FormData/MlssFieldEditor';

import { PDFDocument, PDFTextField, PDFCheckBox, PDFDropdown, PDFOptionList, PDFButton } from 'pdf-lib';
import { CommunicationsTable } from 'coryallen-communications';

import all_zip_codes from '@assets/all_zip_codes.json';

export default {
  page: {
    title: 'MLSs',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, MlssForm, MlssFieldEditor, CommunicationsTable },
  data() {
    return {
      title: 'MLSs',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'MLSs', to: '/mlss', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      time_passed: false,
      changes_made: false,

      all_zip_codes: {},
      selected_state: '',
      selected_city: '',
      state_cities: [],
      selected_zip_codes: [],
      input_zip_codes: '',

      active_pdf: {},
      iframedata: "",
      iframeWidth: 100,
      iframeHeight: 75,
      tabIndex: 0,

      default_new_pdf: {
        mls_id: this.$route.params.id,
        title: '',
        pdf_mapping: [],
        file1: null,
      },
      new_pdf: {},

      order_columns: [],
      mls_field_values: {},

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
        withs: {
          pdfs: {
            total: 0,
          },
        },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Mlss\\Models\\Mls',
      },

    }
  },
  computed: {
    allStates: function() {
      var results = [];
      for(var i in this.all_zip_codes) {
        if(this.all_zip_codes[i].states) { for(var j in this.all_zip_codes[i].states) {
          if(results.indexOf(this.all_zip_codes[i].states[j]) == -1) { results.push(this.all_zip_codes[i].states[j]); }
        }}
      }
      return results;
    },
  },
  watch: {
    'item': { handler: function(n, o) {
      if(this.time_passed) { this.changes_made = true; }
    }, deep: true },
    'item.form_fields': { handler: function(n, o) {
      this.set_mls_field_values();
    }, deep: true },
    'active_pdf': { handler: function(n, o) {
      this.loadPdf();
    }, deep: true },
    'selected_state': { handler: function(n, o) {
      var cities = [];
      var zip_codes = [];
      this.selected_city = "";
      if(this.selected_state) {
        for(var i in this.all_zip_codes) {
          if(this.all_zip_codes[i].states.includes(this.selected_state)) {
            for(var city in this.all_zip_codes[i].cities) {
              if(cities.indexOf(this.all_zip_codes[i].cities[city]) == -1) {
                cities.push(this.all_zip_codes[i].cities[city]);
                zip_codes.push(i);
              }
            }
          };
        }
      }
      this.state_cities = cities;
      this.selected_zip_codes = zip_codes;
    }},
    'selected_city': { handler: function(n, o) {
      var zip_codes = [];
      if(this.selected_state) {
        for(var i in this.all_zip_codes) {
          var adding = false;
          if(this.all_zip_codes[i].states.includes(this.selected_state)) {
            adding = true;
            if(this.selected_city) {
              if(this.all_zip_codes[i].cities.includes(this.selected_city)) { adding = true; } else { adding = false; }
            }
          }
          if(adding) { zip_codes.push(i); }
        }
      }
      this.selected_zip_codes = zip_codes;
    }},
  },
  created() {
    this.all_zip_codes = all_zip_codes;

    this.new_pdf = JSON.parse(JSON.stringify(this.default_new_pdf));
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.time_passed = false;
      this.$http.get('/api/mlss/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          // if(!res.data.data[0].body) { res.data.data[0].body = ''; }
          if(!res.data.data[0].zip_codes) { res.data.data[0].zip_codes = []; }
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.title;
          this.get_order_columns();
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/mlss');
        }
        setTimeout(()=> { this.time_passed = true; }, 5000);
        this.changes_made = false;
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    get_order_columns() {
      this.loading = true;
      this.$http.get('/api/listings/get_columns').then(res => {
        if(res.data) {
          this.order_columns = res.data;
          this.set_mls_field_values();
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    set_mls_field_values() {
      var output = {};
      for(var i in this.order_columns) {
        output[this.order_columns[i]] = {
          used: 0,
          output: '',
        };
      }
      if(this.item && this.item.form_fields) { for(var page in this.item.form_fields) { for(var content in this.item.form_fields[page].content) {
        if(this.item.form_fields[page].content[content].FieldType == 'reso' || this.item.form_fields[page].content[content].FieldType == 'custom') {
          if(output[this.item.form_fields[page].content[content].StandardName]) {
            output[this.item.form_fields[page].content[content].StandardName].used = output[this.item.form_fields[page].content[content].StandardName].used + 1;
          } else {
            output[this.item.form_fields[page].content[content].StandardName] = {
              used: 1,
              output: (this.item.form_fields[page].content[content].Default === null ? '' : this.item.form_fields[page].content[content].Default),
            };
          }
        }
      } } }
      this.mls_field_values = output;
    },
    update_mls() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/mlss/update', this.item).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.changes_made = false;
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_mls() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this MLS?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/mlss/delete/'+this.item.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
              this.$router.push('/mlss');
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    add_pdf() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      const fd = new FormData();
      for(var i in this.new_pdf) { fd.append(i, this.new_pdf[i]); }

      this.$http.post('/api/mlss/pdfs/store', fd).then(res => {
        // console.log(res);
        this.new_pdf = JSON.parse(JSON.stringify(this.default_new_pdf));
        this.$refs.modal_add_pdf.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    delete_pdf(id) {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this PDF?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/mlss/pdfs/delete/'+id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.fetchData();
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    loadPdf() {
      // console.log('goin');
      this.loading = true;
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(this.active_pdf.pdf_url) {
        this.$http.get('/api/mlss/pdfs/fetchpdf', {params: {url: this.active_pdf.pdf_url}, responseType: 'arraybuffer'}).then(res => {
          var myData = new Uint8Array(res.data);
          (async() => {
            const pdfDoc = await PDFDocument.load(myData);
            const form = pdfDoc.getForm();
            const fields = form.getFields();
            fields.forEach(field => {
              // console.log(field);
              const type = field.constructor.name; // Doesn't work when JS is compiled. Use "field instanceof PDFTextField" instead.
              const name = field.getName();
              // console.log(`${type}: ${name}`);
              // PDFTextField
              // PDFSignature
              // PDFCheckBox
              // PDFDropdown
              // PDFOptionList
              // PDFRadioGroup
              
              // For testing
              if(field instanceof PDFTextField) { field.setText(name); }
              if(field instanceof PDFCheckBox) { field.check(); }
              if(field instanceof PDFDropdown) { field.addOptions([name]); field.select(name); }
              if(field instanceof PDFOptionList) { field.addOptions([name]); field.select(name); }

              // Live
              // if(this.mls_field_values.hasOwnProperty(name)) { field.setText(this.mls_field_values[name].output); }
            });
            const pdfBytes = await pdfDoc.save();
            const blobObj = new Blob([pdfBytes], { type: "application/pdf" })
            const docUrl = URL.createObjectURL(blobObj);
            this.iframedata = docUrl;
            this.dsbl_btn = false;
            this.loading = false;
          })();
        }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; this.loading = false; });
      }
    },
    manualAddZipCodes() {
      var zip_codes = this.input_zip_codes.replace(/[^0-9,]/g, '').split(",");
      for(var i in zip_codes) {
        if(zip_codes[i] && !this.item.zip_codes.includes(zip_codes[i])) { this.item.zip_codes.push(zip_codes[i]) }
      }
    },
    addAllZipCodes() {
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to add all zip codes listed above to the covered zip codes?",
        buttons: [
          Noty.button('YES', 'btn btn-success px-4 float-right ml-2', notyres => {
            for(var i in this.selected_zip_codes) {
              if(this.selected_zip_codes[i] && !this.item.zip_codes.includes(this.selected_zip_codes[i])) { this.item.zip_codes.push(this.selected_zip_codes[i]) }
            }
            n.close();
          }, {'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    removeAllZipCodes() {
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to remove all covered zip codes?",
        buttons: [
          Noty.button('REMOVE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            this.item.zip_codes = [];
            n.close();
          }, {'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> RETS mapping</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Coverage</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Form data</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> PDF mapping</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>

    <div v-if="item.id">

      <div v-if="changes_made" class="alert alert-danger mt-4 _c-pointer" @click="changes_made = false"><Icon icon="ri:close-line" class="float-right m-1" /><Icon icon="ri:error-warning-line" /> <small>Don't forget to save any changes made.</small></div>

      <div v-show="tabIndex == 0">
        <div class="row mt-4 set-sm-375">
          <div class="col-lg-4">
            <div class="card-box">
              <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> About :</h5>
              <div class="table-responsive">
                <table class="table table-sm table-px-0">
                  <tbody>
                    <tr>
                      <th class="border-0" v-tippy content="Live status means the MLS is accessible on the client website for visitors to submit new listings."><label>Live <Icon icon="ri:question-line"></Icon> :</label></th>
                      <td class="border-0 small"><div :class="'alert alert-'+(item.status ? 'success' : 'danger')+' small mb-0 px-2 py-1'">{{ item.status ? 'Yes' : 'No' }}</div></td>
                    </tr>
                    <tr>
                      <th><label>Office Name :</label></th>
                      <td class="small">{{item.office_name}}</td>
                    </tr>
                    <tr>
                      <th><label>IDX Type :</label></th>
                      <td class="small">{{item.idx_type}}</td>
                    </tr>
                    <tr>
                      <th><label>Back Office Type :</label></th>
                      <td class="small">{{item.back_office_type}}</td>
                    </tr>
                    <tr>
                      <th><label>Last IDX Run :</label></th>
                      <td class="small" v-tippy :content="item.last_idx ? moment(item.last_idx).format('lll') : ''">{{ item.last_idx ? moment(item.last_idx).fromNow() : '' }}</td>
                    </tr>
                    <tr>
                      <th><label>Last Clean Run :</label></th>
                      <td class="small" v-tippy :content="item.last_clean ? moment(item.last_clean).format('lll') : ''">{{ item.last_clean ? moment(item.last_clean).fromNow() : '' }}</td>
                    </tr>
                    <tr>
                      <th><label>Last Back Office Run :</label></th>
                      <td class="small" v-tippy :content="item.last_bo ? moment(item.last_bo).format('lll') : ''">{{ item.last_bo ? moment(item.last_bo).fromNow() : '' }}</td>
                    </tr>
                    <tr>
                      <th><label>Updated on :</label></th>
                      <td class="small" v-tippy :content="item.updated_at ? moment(item.updated_at).format('lll') : ''">{{ item.updated_at ? moment(item.updated_at).fromNow() : '' }}</td>
                    </tr>
                    <tr>
                      <th><label>Created on :</label></th>
                      <td class="small" v-tippy :content="item.created_at ? moment(item.created_at).format('lll') : ''">{{ item.created_at ? moment(item.created_at).fromNow() : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div class="card-box p-0">
              <div class="card-header bg-primary text-white">Legal IDX preview</div>
              <div class="p-3">
                <p class="mb-3 small text-pre-wrap">{{item.mls_disclaimer}}</p>
                <img v-if="item.mls_logo" :src="formatImage(item.mls_logo)" class="_h-40">
              </div>
            </div>
            
            <div class="card-box p-0">
              <div class="card-header bg-primary text-white">Future info</div>
              <div class="p-3">
<pre>
rets mapping (Number mapped out of total)
coverage (number of zip codes)
form data (Any missing important fields, any duplicate fields)
pdf mapping (number of PDF files)
</pre>
              </div>
            </div>

            <button v-if="hasRole(['Dev','Admin'])" type="button" class="btn btn-block btn-outline-danger" @click="delete_mls" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:delete-bin-7-line" /> Delete MLS</button>

          </div>
          <div class="col-sm-8">
            <div class="card-box">
              <b-form @submit.prevent="update_mls">
                <MlssForm :item="item"></MlssForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>

      <div v-show="tabIndex == 1">
        <div class="row mt-4">
          <div class="col-sm-12">
            <div class="card-box">
              <b-form @submit.prevent="update_mls">
                <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> RETS field mapping :</h5>
                <p class="text-muted small mb-3">Mapping for RETS MLS fields to the database fields.</p>
                <div class="row">
                  <div v-for="(field, field_i) in item.rets_mapping" :key="'i'+field_i" class="col-sm-4">
                    <w-field SimpleDataType="String" :Title="field_i+' :'" v-model="item.rets_mapping[field_i]" LabelClass="text-transform-none"></w-field>
                  </div>
                </div>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>

      <div v-show="tabIndex == 2">
        <div class="row mt-4">
          <div class="col-sm-12">
            <div class="card-box p-0">

              


              

              <div class="row m-0">
                <div class="col-6 p-0">
                  <div class="p-4">
                    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> All Zip Codes :</h5>

                    <div class="row mb-3">
                      <div class="col-6">
                        <w-field SimpleDataType="String List, Single" v-model="selected_state" :Options="allStates" Title="State :" placeholder="State..." Required></w-field>
                      </div>
                      <div class="col-6">
                        <w-field SimpleDataType="String List, Single" v-model="selected_city" :Options="state_cities" Title="City :" placeholder="City..." Required></w-field>
                      </div>
                    </div>

                    <div class="border border-light bg-gray-100 p-2 mb-1 small font-weight-bold">
                      <div class="row m-0">
                        <div class="_w-100">Zip Code</div>
                        <div class="_w-100">State(s)</div>
                        <div class="col p-0">City(s)</div>
                      </div>
                    </div>
                    <div v-for="(zip, zip_i) in selected_zip_codes" :key="'z'+zip_i" class="border border-light bg-hover-gray-100 p-2 mb-1 small _c-pointer" :class="item.zip_codes.includes(zip) ? 'bg-lighten-success' : ''" @click="item.zip_codes.includes(zip) ? '' : item.zip_codes.push(zip)" v-tippy content="Add zip code">
                      <div class="row m-0">
                        <div class="_w-100">{{ zip }}</div>
                        <div class="_w-100"><span v-for="(state, state_i) in all_zip_codes[zip].states" :key="'s'+state_i">{{ state_i == 0 ? state : ', '+state }}</span></div>
                        <div class="col p-0"><Icon icon="ri:arrow-right-fill" class="float-right m-1" /><span v-for="(city, city_i) in all_zip_codes[zip].cities" :key="'c'+city_i">{{ city_i == 0 ? city : ', '+city }}</span></div>
                      </div>
                    </div>

                    <button type="button" class="btn btn-block btn-outline-success mt-5" @click="addAllZipCodes"><Icon icon="ri:arrow-right-fill" /> Add all zip codes</button>

                  </div>
                </div>
                <div class="col-6 p-0 border-left border-light">
                  <div class="p-4">
                    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Covered Zip Codes :</h5>

                    <div class="mb-4">
                      <label for="input_zip_codes">Zip code(s)... <small class="text-muted font-weight-normal">(Separate multiples by commas.)</small></label>
                      <div class="input-group">
                        <input id="input_zip_codes" type="text" class="form-control" placeholder="Zip code(s)..." v-model="input_zip_codes">
                        <div class="input-group-append">
                          <button type="button" class="btn btn-primary" @click="manualAddZipCodes"><Icon icon="ri:add-line"></Icon> Add</button>
                        </div>
                      </div>
                    </div>

                    <div class="border border-light bg-gray-100 p-2 mb-1 small font-weight-bold">
                      <div class="row m-0">
                        <div class="_w-100">Zip Code</div>
                        <div class="_w-100">State(s)</div>
                        <div class="col p-0">City(s)</div>
                      </div>
                    </div>
                    <div v-for="(zip, zip_i) in item.zip_codes" :key="'z'+zip_i" class="border border-light bg-hover-gray-100 p-2 mb-1 small _c-pointer" @click="item.zip_codes.splice(zip_i, 1)" v-tippy content="Remove zip code">
                      <div class="row m-0">
                        <div class="_w-100">{{ zip }}</div>
                        <div class="_w-100"><span v-for="(state, state_i) in all_zip_codes[zip].states" :key="'s'+state_i">{{ state_i == 0 ? state : ', '+state }}</span></div>
                        <div class="col p-0"><Icon icon="ri:delete-bin-7-line" class="float-right m-1" /><span v-for="(city, city_i) in all_zip_codes[zip].cities" :key="'c'+city_i">{{ city_i == 0 ? city : ', '+city }}</span></div>
                      </div>
                    </div>

                    <button type="button" class="btn btn-block btn-outline-danger mt-5" @click="removeAllZipCodes"><Icon icon="ri:delete-bin-7-line" /> Remove all zip codes</button>

                  </div>
                </div>
              </div>
              <div class="border-top border-light mx-3 mb-3 pt-3 text-right">
                <button type="button" class="btn btn-success ml-3" :disabled="dsbl_btn" @click="update_mls"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                <div class="clearfix"></div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div v-show="tabIndex == 3">
        <div class="row mt-4">
          <div class="col-sm-12">
            <MlssFieldEditor :item="item" :mls_field_values="mls_field_values" @update_mls="update_mls"></MlssFieldEditor>
          </div>
        </div>
      </div>

      <div v-show="tabIndex == 4">
        <div class="row mt-4">
          <div class="col-sm-3">
            <div class="card-box p-0">
              <div class="p-2">
                <div class="d-flex">
                  <div class="mr-auto">
                    <h5 class="m-0 p-2">PDF list :</h5>
                  </div>
                  <div class="">
                    <button type="button" class="btn btn-success" @click="new_pdf = JSON.parse(JSON.stringify(default_new_pdf)); $refs.modal_add_pdf.show()"><Icon icon="ri:add-line" /> Add</button>
                    <b-modal ref="modal_add_pdf" centered size="lg" title="Add a new PDF" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
                      <b-form @submit.prevent="add_pdf">
                        <div class="p-3">
                          <!-- <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> PDF Info :</h5>
                          <p class="text-muted small">Please select a title for this PDF as well as a file from you device.</p> -->
                          <div class="row">
                            <div class="col-sm-6">
                              <b-form-group label="PDF Title :" label-for="input-title" description="">
                                <b-form-input id="input-title" v-model="new_pdf.title" type="text" placeholder="Enter PDF title..." required></b-form-input>
                              </b-form-group>
                            </div>
                            <div class="col-sm-6">
                              <b-form-group label="PDF file :" label-for="input-file1" description="">
                                <b-form-file id="input-file1" v-model="new_pdf.file1" :state="Boolean(new_pdf.file1)" placeholder="Choose a PDF or drop it here..." drop-placeholder="Drop file here..." required></b-form-file>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                        <footer class="modal-footer modal-footer-custom">
                          <button type="button" class="btn btn-light" @click="$refs.modal_add_pdf.hide()">Cancel</button>
                          <button type="submit" class="btn btn-primary">Submit</button>
                        </footer>
                      </b-form>
                    </b-modal>
                  </div>
                </div>
              </div>
              <ul class="nav flex-column small">
                <li v-for="(pdf, pdf_i) in item.pdfs" :key="pdf.id" class="nav-item position-relative">
                  <button type="button" class="position-absolute _pos-t-0 _pos-r-0 btn btn-white text-hover-danger border-0 bg-hover-white p-2 m-2" @click="delete_pdf(pdf.id)"><Icon icon="ri:delete-bin-7-line" /></button>
                  <div class="nav-link text-hover-primary _transition-2 border-top border-light p-2 py-3 _c-pointer" @click="active_pdf = pdf">
                    <img src="@assets/images/file-icons/pdf.svg" height="25" class="mr-2">{{pdf.title}}
                  </div>
                </li>
              </ul>
            </div>
            <div class="card-box p-0">
              <div class="p-3 border-bottom border-light">
                <h5 class="m-0">iframe Settings :</h5>
              </div>
              <div class="p-3">
                <w-field SimpleDataType="Number" Title="Width : " Min="5" Max="100" v-model="iframeWidth" lang=""></w-field>
                <w-field SimpleDataType="Number" Title="Height : " Min="5" Max="100" v-model="iframeHeight" lang=""></w-field>
              </div>
            </div>
          </div>
          <div class="col-sm-9">
            <iframe :src="iframedata" frameborder="0" :style="'width:'+iframeWidth+'%;'+'height:'+iframeHeight+'vh;'+'box-shadow: 0 0 10px rgba(0,0,0,0.5);border-radius:5px;'"></iframe>
          </div>
        </div>
      </div>

      <div v-show="tabIndex == 5">
        <div class="row mt-4">
          <div class="col-sm-12">
            <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>
